// extracted by mini-css-extract-plugin
module.exports = {"sort":"JA-z","sortSelect":"KA-z","disabled":"LA-z"};